import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api } from "./api";

const KEY = "larus:slugs";
let byId: Record<string, string> = (() => { try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; } })();
let bySlug: Record<string, string> = Object.fromEntries(Object.entries(byId).map(([k, v]) => [v, k]));
let loaded = false;
let inflight: Promise<void> | null = null;
const subs = new Set<() => void>();

export function loadSlugs(): Promise<void> {
  inflight = inflight || api<Record<string, string>>("/slugs").then((m) => {
    byId = m; bySlug = Object.fromEntries(Object.entries(m).map(([k, v]) => [v, k])); loaded = true;
    sessionStorage.setItem(KEY, JSON.stringify(m)); subs.forEach((f) => f());
  }).catch(() => {}).finally(() => { inflight = null; });
  return inflight;
}
export const clearSlugs = () => { byId = {}; bySlug = {}; loaded = false; sessionStorage.removeItem(KEY); };
if (typeof window !== "undefined") window.addEventListener("larus:changed", () => { loadSlugs(); });

/** Readable build address, e.g. /harbour-sydney-01-build-2 */
export const bp = (pid?: string | null) => `/${(pid && byId[pid]) || pid || ""}`;
export const progUrl = (rid?: string | null) => `/programme/${(rid && byId[rid]) || rid || ""}`;
export const resolvePid = (x?: string) => (x ? bySlug[x] || x : x);
export const slugKnown = (x?: string) => !!x && (!!bySlug[x] || !!byId[x]);
export const slugsLoaded = () => loaded;

export function useSlugs() {
  const [, set] = useState(0);
  useEffect(() => { const f = () => set((n) => n + 1); subs.add(f); return () => { subs.delete(f); }; }, []);
}

/** The programme id behind the readable address in the URL. */
export function usePid() {
  useSlugs();
  const { pid } = useParams();
  return resolvePid(pid);
}
